import { useEffect, useState } from 'react'
import { getConsent, grantConsent, denyConsent } from '../lib/posthog'
import { POLICY_URLS } from '../lib/urls'

// First-party cookie-consent bar for the web app. Opt-in: analytics stays off
// until the user clicks Accept. Reject stores the choice too, so we don't re-ask.
// Reopened from Settings → "Cookie preferences" via the `rr:open-consent` event, so
// a choice can always be changed (GDPR withdrawal). Hidden once a choice exists.
export function ConsentBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (getConsent() == null) setVisible(true)
    const open = () => setVisible(true)
    window.addEventListener('rr:open-consent', open)
    return () => window.removeEventListener('rr:open-consent', open)
  }, [])

  if (!visible) return null

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 p-4">
      <div className="mx-auto flex max-w-3xl flex-col gap-3 rounded-2xl border border-line bg-surface/95 p-4 shadow-lg backdrop-blur sm:flex-row sm:items-center">
        <p className="flex-1 text-sm text-ink-soft">
          We use cookies for analytics to understand how RecipeRoll is used and make
          it better. See our{' '}
          <a
            href={POLICY_URLS.privacy}
            target="_blank"
            rel="noopener noreferrer"
            className="text-terracotta underline"
          >
            Privacy Policy
          </a>
          .
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            onClick={() => {
              denyConsent()
              setVisible(false)
            }}
            className="rounded-lg border border-line px-4 py-2 text-sm font-medium text-ink-soft hover:text-ink cursor-pointer"
          >
            Reject
          </button>
          <button
            type="button"
            onClick={() => {
              grantConsent()
              setVisible(false)
            }}
            className="rounded-lg bg-terracotta px-4 py-2 text-sm font-semibold text-white hover:opacity-90 cursor-pointer"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  )
}
